import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(private meta: Meta,
        private titleService: Title,
        @Inject(DOCUMENT) private doc) { }

    setSeoMetaTags(resp) {
        const content_title = resp.title.rendered;
        const content_description = resp.content.rendered.replace(/(<([^>]+)>)/ig, '');
        const content_image = resp.better_featured_image;

        if (content_image) {
            // Og Image
            const checkmeta_ogimage = document.querySelector('meta[property="og:image"]');
            if (!checkmeta_ogimage) {
                this.meta.addTag({ property: 'og:image', content: content_image.source_url });
            } else {
                this.meta.updateTag({ property: 'og:image', content: content_image.source_url });
            }

            // Og Image Secure Url
            const checkmeta_ogsecure_url_image = document.querySelector('meta[property="og:image:secure_url"]');
            if (!checkmeta_ogsecure_url_image) {
                this.meta.addTag({ property: 'og:image:secure_url', content: content_image.source_url });
            } else {
                this.meta.updateTag({ property: 'og:image:secure_url', content: content_image.source_url });
            }

            // Og Image Dimension
            const checkmeta_image_width = document.querySelector('meta[property="og:image:width"]');
            if (!checkmeta_image_width) {
                this.meta.addTag({ property: 'og:image:width', content: content_image.media_details.width });
            } else {
                this.meta.updateTag({ property: 'og:image:width', content: content_image.media_details.width });
            }

            const checkmeta_image_height = document.querySelector('meta[property="og:image:height"]');
            if (!checkmeta_image_height) {
                this.meta.addTag({ property: 'og:image:height', content: content_image.media_details.height });
            } else {
                this.meta.updateTag({ property: 'og:image:height', content: content_image.media_details.height });
            }

            const checkmeta_image_alt = document.querySelector('meta[property="og:image:alt"]');
            if (!checkmeta_image_alt) {
                this.meta.addTag({ property: 'og:image:alt', content: content_image.alt_text });
            } else {
                this.meta.updateTag({ property: 'og:image:alt', content: content_image.alt_text });
            }

            const checkmeta_image_type = document.querySelector('meta[property="og:image:type"]');
            const image_type = content_image.media_details.sizes.large['mime-type'];
            if (!checkmeta_image_type) {
                this.meta.addTag({ property: 'og:image:type', content: image_type });
            } else {
                this.meta.updateTag({ property: 'og:image:type', content: image_type });
            }
        }

        var meta_title;
        if (content_title === 'Home') {
            meta_title = 'Pulla - Art meets science.';
        } else {
            meta_title = content_title + ' - Pulla';
        }
        this.titleService.setTitle(meta_title);

        //Title
        const checkmeta_title = document.querySelector('meta[property="title"]');
        if (!checkmeta_title) {
            this.meta.addTag({ property: 'title', content: meta_title });
        } else {
            this.meta.updateTag({ property: 'title', content: meta_title });
        }

        //Og:Title
        const checkmeta_ogtitle = document.querySelector('meta[property="og:title"]');
        if (!checkmeta_ogtitle) {
            this.meta.addTag({ property: 'og:title', content: meta_title });
        } else {
            this.meta.updateTag({ property: 'og:title', content: meta_title });
        }

        //Twitter:Title
        const checkmeta_twittertitle = document.querySelector('meta[property="twitter:title"]');
        if (!checkmeta_twittertitle) {
            this.meta.addTag({ property: 'twitter:title', content: meta_title });
        } else {
            this.meta.updateTag({ property: 'twitter:title', content: meta_title });
        }

        //Description
        const check_meta_name = document.querySelector('meta[name="description"]');
        if (!check_meta_name) {
            this.meta.addTag({ name: 'description', content: content_description });
        } else {
            this.meta.updateTag({ name: 'description', content: content_description });
        }

        const checkmeta_description = document.querySelector('meta[property="description"]');
        if (!checkmeta_description) {
            this.meta.addTag({ property: 'description', content: content_description });
        } else {
            this.meta.updateTag({ property: 'description', content: content_description });
        }

        //Og:Description
        const checkmeta_ogdescription = document.querySelector('meta[property="og:description"]');
        if (!checkmeta_ogdescription) {
            this.meta.addTag({ property: 'og:description', content: content_description });
        } else {
            this.meta.updateTag({ property: 'og:description', content: content_description });
        }

        //Twitter:Description
        const checkmeta_twitterdescription = document.querySelector('meta[property="twitter:description"]');
        if (!checkmeta_twitterdescription) {
            this.meta.addTag({ property: 'twitter:description', content: content_description });
        } else {
            this.meta.updateTag({ property: 'twitter:description', content: content_description });
        }

        //Og:Locale
        const checkmeta_locale = document.querySelector('meta[property="og:locale"]');
        if (!checkmeta_locale) {
            this.meta.addTag({ property: 'og:locale', content: 'en_US' });
        }

        //Og:type
        const checkmeta_type = document.querySelector('meta[property="og:type"]');
        if (!checkmeta_type) {
            this.meta.addTag({ property: 'og:type', content: 'website' });
        }

        //Og:sitename
        const checkmeta_sitename = document.querySelector('meta[property="og:site_name"]');
        if (!checkmeta_sitename) {
            this.meta.addTag({ property: 'og:site_name', content: 'Pulla' });
        }

        //Og:url
        const checkmeta_url = document.querySelector('meta[property="og:url"]');
        if (!checkmeta_url) {
            this.meta.addTag({ property: 'og:url', content: window.location.href });
        } else {
            this.meta.updateTag({ property: 'og:url', content: window.location.href });
        }

        //Link 
        const checkmeta_link = document.querySelector('link[rel="canonical"]');
        if (!checkmeta_link) {
            let link: HTMLLinkElement = this.doc.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', window.location.href);
            this.doc.head.appendChild(link);
        } else {
            checkmeta_link.setAttribute('href', window.location.href);
        }

        const checmeta_time = document.querySelector('meta[property="og:updated_time"]');
        var meta_date = new Date().toISOString();
        if (!checmeta_time) {
            this.meta.addTag({ property: 'og:updated_time', content: meta_date });
        } else {
            this.meta.updateTag({ property: 'og:updated_time', content: meta_date });
        }
    }
}
